import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, SENDER_NAMES_CREATE, SENDER_NAMES_EDIT} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {SENDER_NAME_LIST} from "../../../../api/routing/routes/admin.backend.app";
import {Link} from "react-router-dom";
import moment from "moment";
import {SenderName} from "../../../../api/model/user";

export const SenderNames = () => {
  const {t} = useTranslation();
  const columnHelper = createColumnHelper<SenderName>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    }),
    columnHelper.accessor('name', {
      header: () => t('Name'),
    }),
    columnHelper.accessor('company', {
      header: () => t('Organization'),
      cell: info => info.getValue().name
    }),
    columnHelper.accessor('isApproved', {
      header: () => t('Approved?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('createdAt.datetime', {
      header: () => t('Created at'),
      cell: info => moment(info.getValue()).format('lll')
    }),
    columnHelper.accessor('uuid', {
      header: () => t('Actions'),
      cell: info => (
        <Link to={SENDER_NAMES_EDIT.replace(':id', info.getValue())} className="btn btn-primary">
          {t('Update')}
        </Link>
      )
    })
  ];

  return (
    <DashboardLayout
      title="Sender Names"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Sender Names'), current: true}
      ]}
      buttons={[
        <Link to={SENDER_NAMES_CREATE} className="float-end btn btn-primary">{t('Create')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('List')}
              </h5>
              <TableComponent columns={columns} url={SENDER_NAME_LIST} params={{
                isApproved: false
              }}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
